import { Skeleton } from "@/components/ui/skeleton";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import type { TopPagePoint } from "../../api/statsApi";

interface TopPagesTableProps {
  points: TopPagePoint[];
  isLoading: boolean;
}

const formatEngagement = (seconds: number) => {
  const total = Math.max(0, Math.round(seconds));
  const minutes = Math.floor(total / 60);
  const remainder = total % 60;
  return `${minutes}m ${remainder}s`;
};

export const TopPagesTable = ({ points, isLoading }: TopPagesTableProps) => {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Página</TableHead>
          <TableHead className="text-right">Vistas</TableHead>
          <TableHead className="text-right">Engagement promedio</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {isLoading ? (
          Array.from({ length: 5 }).map((_, idx) => (
            <TableRow key={`skeleton-${idx}`}>
              <TableCell>
                <Skeleton className="h-4 w-3/4" />
              </TableCell>
              <TableCell className="text-right">
                <Skeleton className="ml-auto h-4 w-16" />
              </TableCell>
              <TableCell className="text-right">
                <Skeleton className="ml-auto h-4 w-20" />
              </TableCell>
            </TableRow>
          ))
        ) : points.length === 0 ? (
          <TableRow>
            <TableCell
              colSpan={3}
              className="text-center text-muted-foreground"
            >
              Sin datos
            </TableCell>
          </TableRow>
        ) : (
          points.map((point) => (
            <TableRow key={point.path}>
              <TableCell className="font-mono text-xs">{point.path}</TableCell>
              <TableCell className="text-right tabular-nums">
                {point.pageViews.toLocaleString("es-AR")}
              </TableCell>
              <TableCell className="text-right tabular-nums">
                {formatEngagement(point.avgEngagementTimeSec)}
              </TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  );
};
